import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, TrendingUpIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Tools',
    href: '#tools'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0a0a1a]/80 backdrop-blur-md border-b border-white/10 py-4' : 'bg-transparent py-6'}`} data-id="element-164">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165">
        <div className="flex justify-between items-center" data-id="element-166">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group" data-id="element-167">
            <div className="bg-gradient-to-br from-blue-500 to-cyan-400 p-2 rounded-lg group-hover:shadow-[0_0_15px_rgba(59,130,246,0.5)] transition-shadow" data-id="element-168">
              <TrendingUpIcon className="w-6 h-6 text-white" data-id="element-169" />
            </div>
            <span className="text-xl font-bold tracking-tight text-white" data-id="element-170">
              Scale
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400" data-id="element-171">
                Finance
              </span>
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-172">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-300 hover:text-white transition-colors" data-id="element-173">
                {link.name}
              </a>)}
            <a href="#contact" className="px-5 py-2.5 rounded-full bg-white/10 hover:bg-white/20 border border-white/10 text-white text-sm font-medium transition-all hover:shadow-[0_0_20px_rgba(59,130,246,0.3)]" data-id="element-174">
              Book Consultation
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-slate-300 hover:text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-175">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-176" /> : <MenuIcon className="w-6 h-6" data-id="element-177" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-[#0a0a1a]/95 backdrop-blur-xl border-b border-white/10 py-4 px-4 flex flex-col gap-4 shadow-2xl" data-id="element-178">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-slate-300 hover:text-white p-2 rounded-lg hover:bg-white/5 transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-179">
              {link.name}
            </a>)}
          <a href="#contact" className="mt-2 text-center px-5 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-medium" onClick={() => setIsMobileMenuOpen(false)} data-id="element-180">
            Book Consultation
          </a>
        </div>}
    </nav>;
}